import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  button: {
    '& svg path': {
      transition: `fill ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn}, stroke ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn}`,
    },
    '&:first-child': {
      '&::after': {
        background: `rgb(${theme.palette.mineShaft})`,
        content: "''",
        height: '100%',
        position: 'absolute',
        right: 0,
        top: 0,
        width: '1px',
      },
      paddingRight: '1rem',
    },
    '&:hover, &:focus': {
      color: `rgb(${theme.palette.white})`,
      outline: 0,
    },
    '&:last-child': {
      '& span': {
        bottom: '-1px',
        position: 'relative',
      },
    },
    alignItems: 'center',
    background: 'transparent',
    border: 0,
    color: `rgb(${theme.palette.doveGray})`,
    cursor: 'pointer',
    display: 'inline-flex',
    fontSize: '0.875rem',
    padding: '0.22rem 0.875rem',
    position: 'relative',
    textTransform: 'uppercase',
    transition: `color ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn}`,
  },
  buttonGrid: {
    '& svg': {
      '& path': {
        fill: `rgb(${theme.palette.doveGray})`,
      },
      marginLeft: '0.55rem',
    },
    '&:hover, &:focus': {
      '& svg path': {
        fill: `rgb(${theme.palette.white})`,
      },
    },
  },
  buttonGridSelected: {
    '& svg': {
      '& path': {
        fill: `rgb(${theme.palette.white})`,
      },
    },
  },
  buttonGroup: {
    marginBottom: '1.5rem',
  },
  buttonList: {
    '& svg': {
      marginRight: '0.55rem',
      stroke: `rgb(${theme.palette.doveGray})`,
    },
    '&.button--selected': {
      color: `rgb(${theme.palette.white})`,
    },
    '&:hover, &:focus': {
      '& svg path': {
        stroke: `rgb(${theme.palette.white})`,
      },
    },
  },
  buttonListSelected: {
    '& svg path': {
      stroke: `rgb(${theme.palette.white})`,
    },
  },
  gridHeader: {
    backgroundColor: `rgb(${theme.palette.black})`,
    boxShadow: `0px 15px 15px rgb(${theme.palette.black})`,
    margin: '0 auto',
    paddingTop: '6rem',
    position: 'relative',
    textAlign: 'center',
    width: '100%',
    zIndex: '99',
    [theme.breakpoints.up('sm')]: {
      // margin: '0',
    },
  },
  gridHeaderFilter: {},
  gridHeaderSort: {},
  gridHeaderYear: {},
  leadText: {
    backgroundColor: 'inherit',
    boxShadow: 'inherit',
    color: `rgb(${theme.palette.dustyGray})`,
    fontFamily: theme.typography.tertiary,
    fontSize: '0.825rem',
    padding: '0 0.5rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.125rem',
      padding: 0,
    },
  },
  selected: {
    color: `rgb(${theme.palette.white})`,
  },
  sortFilterContainer: {
    '&:empty': {
      display: 'none',
    },
    backgroundColor: 'inherit',
    boxShadow: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '1rem 0',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  title: ({ categoryId }) => ({
    '&::before': {
      bottom: 0,
      color: `rgb(var(--${categoryId}_rgb))`,
      content: 'attr(data-text)',
      fontSize: '2.1rem',
      left: 0,
      position: 'absolute',
      right: 0,
      [theme.breakpoints.up('ty')]: {
        fontSize: '2.6rem',
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '4rem',
      },
    },
    '-webkit-text-stroke': `1px rgba(var(--${categoryId}_rgb), 0.4)`,
    backgroundColor: 'inherit',
    boxShadow: 'inherit',
    color: `rgb(${theme.palette.black})`,
    fontFamily: "'Industry', sans-serif",
    fontSize: '2.2rem',
    marginBottom: '0',
    position: 'relative',
    textTransform: 'uppercase',
    [theme.breakpoints.up('ty')]: {
      fontSize: '2.8rem',
      marginBottom: '0',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '4.3rem',
      marginBottom: '0',
    },
  }),
  yearTitle: {
    '&::before': {
      color: `rgb(${theme.palette.white}) !important`,
      content: 'attr(data-text)',
    },
    '-webkit-text-stroke': `1px rgb(${theme.palette.white}) !important`,
    backgroundColor: 'inherit',
    boxShadow: 'inherit',
  },
}))

export default useStyles
